export default __webpack_public_path__ + "static/icon-26-6-ad0780f741ce9ed9452a38da5873d10c.png";